export default function About() {
  return (
    <section
      id="about"
      className="section about"
      style={{
        backgroundColor: "#28a745",
        color: "#ffffff",
        padding: "40px 60px",
        boxSizing: "border-box",
      }}
    >
      <h2 style={{ marginBottom: "20px", fontSize: "1.6rem", textAlign: "left" }}>
        About Us - PlantAChild
      </h2>

      <div
        style={{
          display: "flex",
          gap: "80px",
          alignItems: "flex-start",
          fontSize: "0.9rem",
        }}
      >

        {/* Contact */}
        <div>
          <h4 style={{ marginBottom: "6px" }}>Contact</h4>
          <p>Email: rranjeet@gmail.com</p>
         </div>
      </div>

      <p
        style={{
          marginTop: "30px",
          textAlign: "center",
          fontSize: "0.8rem",
          opacity: 0.9,
        }}
      >
        © PlantAChild. All rights reserved
      </p>
    </section>
  );
}
